import { HttpClient, HttpParams } from '@angular/common/http';
import { Response } from '@angular/http';
import { Injectable} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { ActionRecommendationRuleDetailsViewModel, ActionRecommendationsViewModel, ActionRecommendationsSearchFiltersViewModel, ActionRecommendationAttachRulesViewModel, ActionRecommendationAttachRuleViewModel } from './action-recommendations.model';
import { Tuple } from '../../entities';

@Injectable()
export class ActionRecommendationService {

    constructor(private _http: HttpClient) { }

  public GetCustomerJobSiteModelForInspection(InspectionId: number): Observable<ActionRecommendationsSearchFiltersViewModel> {
    return this._http.get<ActionRecommendationsSearchFiltersViewModel>("api/ActionRecommendationRules/GetCustomerJobSiteModelForInspection?InspectionId=" + InspectionId.toString(),).pipe(catchError(this.handleError));
  }

  public GetActionRecommendationRules(RuleId: number, CustomerId: number, JobSiteId: number, ModelId: number): Observable<ActionRecommendationsViewModel[]> {
    return this._http.get<ActionRecommendationsViewModel[]>("api/ActionRecommendationRules/GetActionRecommendationRules?RuleId=" + RuleId.toString() + "&CustomerId=" + CustomerId.toString() + "&JobSiteId=" + JobSiteId.toString() + "&ModelId=" + ModelId.toString(),).pipe(catchError(this.handleError));
  }
  public GetActionRecommendationRulesQuotes(inspectionId: number): Observable<ActionRecommendationsViewModel[]> {
    return this._http.get<ActionRecommendationsViewModel[]>("api/ActionRecommendationRules/GetActionRecommendationRulesQuotes?InspectionId=" + inspectionId.toString(),).pipe(catchError(this.handleError));
  }

  public SetActionRecommendationRules(ARVM: ActionRecommendationsViewModel): Observable<any> {
    return this._http.post("api/ActionRecommendationRules/SetActionRecommendationRule", ARVM).pipe(catchError(this.handleError));
  }

  public GetActionRecommendationRuleComponents(RuleId: number): Observable<ActionRecommendationRuleDetailsViewModel[]> {
    return this._http.get<ActionRecommendationRuleDetailsViewModel[]>("api/ActionRecommendationRules/GetActionRecommendationRuleDetails?RuleId=" + RuleId.toString(),).pipe(catchError(this.handleError));
  }

  public AddActionRecommendationRuleComponent(ARVM: ActionRecommendationRuleDetailsViewModel): Observable<any> {
    return this._http.post("api/ActionRecommendationRules/AddActionRecommendationRuleComponent", ARVM).pipe(catchError(this.handleError));
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
  public GetActionRecommendationRulesAndDetails(InspectionId: number, quoteId: number): Observable<ActionRecommendationAttachRulesViewModel[]> {
    return this._http.get<ActionRecommendationAttachRulesViewModel[]>("api/ActionRecommendationRules/GetActionRecommendationRulesAndDetails?InspectionId=" + InspectionId.toString() + "&QuoteId=" + quoteId.toString(),).pipe(catchError(this.handleError));
  }

  public AttachActionRecommendationRule(ARVM: ActionRecommendationAttachRuleViewModel) {
    return this._http.post("api/ActionRecommendationRules/AttachActionRecommendationRule", ARVM).pipe(catchError(this.handleError));
  }

  public AddActionRecommendationRulesQuotes(ARVM: ActionRecommendationAttachRuleViewModel) {
    return this._http.post("api/ActionRecommendationRules/AddActionRecommendationRulesQuotes", ARVM).pipe(catchError(this.handleError));
  }

  public deleteRuleComponentDetail(inspectionId: number, ruleComponentId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionId', inspectionId.toString()).set('RuleComponentId', ruleComponentId.toString())
    };
    return this._http.delete<Tuple>('api/ActionRecommendationRules/DeleteActionRecommendationRuleComponent', options).pipe(catchError(this.handleError));
  }

}
